import { parseLabelledBlocks } from "@/components/assistant/formatWriteApprovalSummary";

export type ContractTypePlanDraft = {
  name: string;
  value: string;
  guidelines: string;
  id?: string;
};

const LABEL_PURPOSE = /^(?:Purpose|Scope(?:\s*&\s*purpose)?):\s*(.*)$/im;

function str(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

export function contractTypePlanDraftFromProposal(
  proposal: Record<string, unknown>
): ContractTypePlanDraft {
  return {
    name: str(proposal.name),
    value: str(proposal.value),
    guidelines: str(proposal.guidelines),
    id: str(proposal.id) || undefined,
  };
}

export function mergeContractTypePlanDraft(draft: ContractTypePlanDraft): {
  name: string;
  value: string;
  guidelines: string;
  id?: string;
} {
  return {
    name: draft.name.trim(),
    value: draft.value.trim(),
    guidelines: draft.guidelines.trim(),
    id: draft.id,
  };
}

export function proposalFingerprint(proposal: Record<string, unknown>): string {
  const merged = mergeContractTypePlanDraft(contractTypePlanDraftFromProposal(proposal));
  return JSON.stringify({
    name: merged.name,
    value: merged.value,
    guidelines: merged.guidelines,
    id: merged.id ?? "",
  });
}

export function draftFingerprint(draft: ContractTypePlanDraft): string {
  return JSON.stringify(mergeContractTypePlanDraft(draft));
}

export function firstPurposeFromGuidelines(guidelines: string): string {
  const blocks = parseLabelledBlocks(guidelines);
  const scope = blocks.find((b) => b.label === "Scope & purpose");
  if (scope?.body) return scope.body.split("\n")[0]?.trim() ?? "";
  const match = guidelines.match(LABEL_PURPOSE);
  return match?.[1]?.trim() ?? "";
}
